import React from "react";
import { uploadImgList, uploadImgListEnum } from "./constant";
var ImagePopup = function (props) {
    return (React.createElement("div", { className: "position-absolute image-popup bg_white" },
        uploadImgList &&
            uploadImgList.map(function (item, i) {
                return (React.createElement("div", { key: i, className: "DMSanM_14_500 " },
                    React.createElement("input", { type: "file", id: item.value, className: "d-none", multiple: true, onChange: function (e) {
                            return props.onSelectFile(e, item.value, item.value === uploadImgListEnum.CLIENT_PROFILE
                                ? true
                                : false);
                        } }),
                    React.createElement("label", { htmlFor: item.value, className: "txt_blackOne1 text-decoration-underline hand_cursor image-label" }, item.title)));
            }),
        React.createElement("div", { className: "DMSanN_14_400 txt_primaryGrey text-right" }, "Accepted file format .Jpg, .Png")));
};
export default ImagePopup;
